import { render, staticRenderFns } from "./StudyUnitInformation.vue?vue&type=template&id=42954a42&scoped=true&lang=pug&"
import script from "./StudyUnitInformation.vue?vue&type=script&lang=ts&"
export * from "./StudyUnitInformation.vue?vue&type=script&lang=ts&"
import style0 from "./StudyUnitInformation.vue?vue&type=style&index=0&id=42954a42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42954a42",
  null
  
)

export default component.exports